module.exports = __webpack_public_path__ + "static/img/introduce.00b52010.png";